<template>
    <div class="material-miniProgram-container">
        <div class="material-miniProgram-title">
            <div class="title-icon">
                <span />
                <span />
            </div>
            <div class="text-info">
                {{ msg.appName }}
            </div>
        </div>
        <div class="material-miniProgram-corver">
            <img
                :src="msg.shareImg"
                alt=""
            >
        </div>
        <div class="material-miniProgram-footer">
            <v-icon
                name="miniprogram-icon"
                class="miniprogram-icon"
            /><span>小程序</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppletCard',
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            msg: {},
        };
    },
    watch: {
        item(val) {
            this.msg = val;
        },
    },
    mounted() {
        if (this.item && this.item.appName !== undefined) {
            this.msg = this.item;
        } else {
            this.update(this.item.materialId);
        }
    },
    methods: {
        update(id) {
            this.$ajax.get(`/ea/material/miniPrograms/detail?id=${id}`).then((res) => {
                this.msg = res.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
    .material-miniProgram-container {
        width: 232px;
        height: 273px;
        border: 1px solid #DADEE7;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 11px 12px;
        .material-miniProgram-title {
            .title-icon {
                display: flex;
                align-items: center;
                span {
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background-color: #E1E6F0;
                    &:nth-last-of-type(1) {
                        margin-left: 5px;
                        width: 40px;
                        height: 10px;
                        background-color: #E1E6F0;
                        border-radius: 1px;
                    }
                }
            }
            .text-info {
                overflow: hidden;
                margin-top: 9px;
                margin-bottom: 9px;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: PingFang SC;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                color: #1E2330;

            }
        }
        .material-miniProgram-corver {
            width: 208px;
            height: 167px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .material-miniProgram-footer {
            margin-top: 6px;
            .miniprogram-icon {
                width: 15px;
                height: 13px;
                vertical-align: middle;
            }
            span {
                margin-left: 4px;
                font-family: PingFang SC;
                font-style: normal;
                font-weight: normal;
                font-size: 13px;
                line-height: 13px;
                color: #A1ABC2;
                vertical-align: middle;
            }
        }
    }
</style>
